import {createSlice} from '@reduxjs/toolkit';
import {updateDetailsApi} from "../../api/myprofile/updateDetailsApi";

export const updateDetailsSlice = createSlice({
    name: 'users',
    initialState: {
        request: false,
        messageTitle: '',
        message: '',
        outcome: 'pending',
    },
    reducers: {
        showError(state, action) {
            state.request = false;
            state.outcome = 'fail';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        showSuccess(state, action) {
            state.request = false;
            state.outcome = 'success';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        cancelError(state) {
            state.request = false;
            state.outcome = 'pending';
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateDetailsApi.pending, (state, action) => {
                state.request = true;
            })
            .addCase(updateDetailsApi.fulfilled, (state, action) => {
                state.request = false;
                state.outcome = 'success';
                state.message = '';
            })
            .addCase(updateDetailsApi.rejected, (state, action) => {
                const { payload } = action;
                state.request = false;
                state.outcome = 'fail';
                state.messageTitle = 'Error';
                //@ts-ignore
                state.message = payload.message;
            })
    },
});

export const { cancelError, showError, showSuccess } = updateDetailsSlice.actions

export default updateDetailsSlice.reducer;